import { StoreEnhancer, StoreEnhancerStoreCreator } from '@reduxjs/toolkit';
import { RootInitialState } from 'core/common/store/rootReducer';
import { isObjectMatch } from 'core/common/utils/isObjectMatch';
import { FeatureFlags } from 'core/feature-flags/services';
import { getFeatureFlagsAttributes } from '../selectors';

export const featureFlagsAttrObserver = (featureFlags: FeatureFlags): StoreEnhancer =>
  ((createStore: StoreEnhancerStoreCreator) => (reducer, preloadedState) => {
    const store = createStore(reducer, preloadedState);

    const updateAttributes = () => {
      const state = store.getState() as unknown as RootInitialState;
      const newAttributes = getFeatureFlagsAttributes(state);
      const currentAttributes = featureFlags.getAttributes();

      const shouldUpdate = !isObjectMatch(currentAttributes, newAttributes);

      if (shouldUpdate) {
        featureFlags.setAttributes(newAttributes);
      }
    };

    updateAttributes();
    store.subscribe(updateAttributes);

    return store;
  }) as StoreEnhancer;
